'use client';

import CloseIcon from '@mui/icons-material/Close';
import { Drawer, IconButton, Typography } from '@mui/material';

/**
 * `md`: reading / single-column editing (view JD, assessment templates).
 * `lg`: an editor plus a side panel (create JD with the JD Assistant).
 * vw widths sprawl on large monitors (85vw ≈ 2200px at 27"), so both are capped.
 */

/** `page`: white. `muted`: grey, for content made of white cards (assessment competencies). */

const PAPER_WIDTH = {
  md: {
    width: {
      xs: '100vw',
      md: '70vw'
    },
    maxWidth: 1120
  },
  lg: {
    width: {
      xs: '100vw',
      md: '90vw',
      lg: '85vw'
    },
    maxWidth: 1440
  }
};
/** Right-anchored drawer frame shared by the job form's drawers: one width scale and surface. */
export function SideDrawer({
  open,
  onClose,
  size = 'md',
  surface = 'page',
  children
}) {
  return <Drawer open={open} anchor="right" onClose={onClose} slotProps={{
    paper: {
      sx: {
        ...PAPER_WIDTH[size],
        height: {
          xs: '85%',
          md: '100%'
        },
        bgcolor: surface === 'muted' ? 'var(--muted)' : 'var(--page)',
        borderRadius: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
      }
    }
  }}>
            {children}
        </Drawer>;
}
/** The drawer's title row (always white, also on a `muted` drawer). Rendered by the content (not the frame) so its actions can use the content's own state. */
export function SideDrawerHeader({
  title,
  slot,
  actions,
  onClose,
  closeTestId
}) {
  return <div className="flex shrink-0 items-center gap-3 border-b border-border bg-page px-6 pt-6 pb-4">
            <Typography component="h2" sx={{
      fontSize: 24,
      fontWeight: 600,
      lineHeight: 1.3
    }} className="shrink-0">
                {title}
            </Typography>
            <div className="min-w-0 flex-1">{slot}</div>
            {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
            <IconButton aria-label="Close" onClick={onClose} size="small" sx={{
      color: 'var(--foreground-muted)'
    }} data-testid={closeTestId}>
                <CloseIcon fontSize="small" />
            </IconButton>
        </div>;
}